import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TITLE_DEFAULT = 'Не удалось получить возможные варианты';
var TEXT_DEFAULT = 'Попробуйте ещё раз';
export var Message = function Message(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? TITLE_DEFAULT : _props$title,
    _props$text = props.text,
    text = _props$text === void 0 ? TEXT_DEFAULT : _props$text;
  return /*#__PURE__*/_jsx("div", {
    className: styles['message_geo'],
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['message_text'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['message_text--title'],
        children: /*#__PURE__*/_jsx("strong", {
          children: title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['message_text--light'],
        children: text
      })]
    })
  });
};